﻿import React, { useState, useEffect, useRef } from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert, Button, Form } from 'react-bootstrap';
import { HalfState } from '../../models/enums/HalfState';

function getCategorizationControls(categoriesList, selectedCategories, incrememtCb, decrementDb) {
    if (categoriesList && categoriesList.length > 0) {
        let categorizationControls = [];
        for (let i = 0; i < categoriesList.length; i++) {
            const currentGroup = categoriesList[i];
            categorizationControls.push(<small key={`group-${currentGroup.id}`}>{currentGroup.name}</small>);

            for (let j = 0; j < currentGroup.categories.filter(x => x.name !== 'Drop Goal').length; j++) {
                const current = currentGroup.categories[j];
                const selectedCount = selectedCategories[current.id] ? selectedCategories[current.id] : 0;
                if (current.name !== 'Drop Goal')
                {
                    categorizationControls.push(getCategorizationControl(selectedCount, current, incrememtCb, decrementDb));
                }
            }
        }

        return categorizationControls;
    } else {
        return [];
    }
}

function getCategorizationControl(selectedCount, config, incrementCb, decrementCb) {
    let variant = selectedCount > 0 ? "success" : "outline-secondary";

    let classNames = `btn btn-block btn-${variant} btn-sm text-left`;

    return (
        <div key={config.id} style={{ padding: ".1rem .1rem" }}>
            <div
                className={classNames}
                onClick={(event) => { incrementCb(config.id); event.preventDefault(); event.stopPropagation(); }}
                style={{ padding: ".1rem .1rem", fontSize: "12px" }}>

                <span className="ml-1">
                    {config.name}
                </span>


                <div className="float-right">

                    <span className="mx-1">{selectedCount}</span>

                </div>
            </div>
            <div>

            </div>
        </div>

    );
}


function getDescriptionControls(descriptionOptions, selectedDescription, setActiveCb, setIsDescriptionListEmpty ) {
    if (descriptionOptions && descriptionOptions.length > 0) {
        let descriptionList = [];
        for (let i = 0; i < descriptionOptions.length; i++) {
            const description = descriptionOptions[i];
            let selectedDescriptionId;
            let isSelected = false
            if (selectedDescription)
            {
                selectedDescriptionId = selectedDescription[0] ? selectedDescription[0].descriptionId : selectedDescription.id
                isSelected = selectedDescription && description.id == selectedDescriptionId;
            }
            descriptionList.push(getDescriptionControl(description, isSelected, setActiveCb, setIsDescriptionListEmpty ));
        }
        return descriptionList;
    } else {
        return [];
    }
}

function getDescriptionControl(description, isSelected, setActiveCb, setIsDescriptionListEmpty ) {
    let variant = isSelected ? "danger" : "outline-danger"
    return (
        <div key={description.id} style={{ padding: ".1rem .1rem" }}>
            <Button
                className="btn-block"
                variant={variant}
                size="sm"
                onClick={(event) => {
                    if (isSelected) {
                        setActiveCb(null);
                    } else {
                        setActiveCb(description);
                    }
                    setIsDescriptionListEmpty(true); 
                }}
                style={{ padding: ".1rem .1rem", fontSize: "12px" }}>
                {description.description}
            </Button>
            </div>
    )
}

const CategorizationScoringControls = (props) => {

    const {
        descriptionOptions,
        categoriesList,
        selectedCategories,
        setSelectedCategories,
        selectedDescription,
        setSelectedDescription,
        setIsDescriptionListEmpty
    } = props;

    let incrementCategorizationInput = (key) => {
        const selectedCount = selectedCategories[key] ? selectedCategories[key] : 0;
        const newSelectedCategories = { ...selectedCategories }
        newSelectedCategories[key] = selectedCount + 1
        setSelectedCategories(newSelectedCategories);
    }

    let decrementCategorizationInput = (key) => {
        const selectedCount = selectedCategories[key] ? selectedCategories[key] : 0;
        if (selectedCount && selectedCount > 0) {
            const newSelectedCategories = { ...selectedCategories }
            newSelectedCategories[key] = selectedCount - 1;
            setSelectedCategories(newSelectedCategories);
        }
    }

    let categorizationInputControls = getCategorizationControls(categoriesList, selectedCategories, incrementCategorizationInput, decrementCategorizationInput);

    let descriptionInputControls = getDescriptionControls(descriptionOptions, selectedDescription, setSelectedDescription, setIsDescriptionListEmpty );
    
    return (
        <>
            <Col lg="8" style={{ paddingLeft: "5px", paddingRight: "5px"}}>
                <div style={{ height: "calc(100vh - 400px)", overflowY: "scroll" }}>
                    {categorizationInputControls}
                    <span style={{ fontSize: "13px" }} >
                        Description
                    </span>
                    {descriptionInputControls}
                </div>
            </Col>
        </>
    );
}

export default CategorizationScoringControls;
